/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedDiagnosisListSchema } from '../models/PagedDiagnosisListSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DiagnosisApi {
    /**
     * Get Diagnosis List
     * Get diagnosis list. <br>Required permission: get_diagnosis_list
     * @returns PagedDiagnosisListSchema OK
     * @throws ApiError
     */
    public static insuranceGetDiagnosisListGet({
        search,
        limit = 100,
        offset,
    }: {
        search?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedDiagnosisListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/diagnosis/diagnosis/',
            query: {
                'search': search,
                'limit': limit,
                'offset': offset,
            },
        });
    }
}
